import styled from 'styled-components';

import { StyledTopNavBar } from '../../AnimatedNavBar/AnimatedNavBar.styles';

export const StyledTopNav = styled(StyledTopNavBar)<{
  visible: boolean;
  direction: 'left' | 'right';
}>`
  inset: ${({ direction }) => (direction === 'left' ? '0 auto auto 0' : '0 0 auto auto')};
  transform: ${({ visible }) => `translateY(${!visible ? '-100%' : '0'})`};
`;
